import classnames from 'classnames';
import { PropsWithChildren } from 'react';
import Div from './Div';

type ContainerProps = {
  className?: string;
  dataTestId?: string;
};

const Container = ({ children, className, dataTestId }: PropsWithChildren<ContainerProps>) => (
  <Div
    className={classnames('container mx-auto px-6 max-w-7xl', className)}
    dataTestId={dataTestId}
  >
    {children}
  </Div>
);

export default Container;
